const timelineParentType = {
  PAYMENT: 1,
  INVOICE: 2,
};

const timelineTitle = {
  PAID: 'PAID',
  AT_CONSIGNEE: 'AT CONSIGNEE',
};

const timelineLabels = {
  INDENT_CREATED: 'indent_created',
  VEHICLE_REQUIREMENT_DATE: 'vehicle_requirement_date',
  VEHICLE_ASSIGNED: 'vehicle_assigned',
  ARRIVAL_SLA_BREACHED: 'arrival_sla_breached',
  REPORTED: 'reported',
  SOURCE_ARRIVED: 'source_arrived',
  SOURCE_DISPATCHED: 'source_dispatched',
  DESTINATION_REPORTED: 'destination_reported',
  DESTINATION_RELEASED: 'destination_reached',
  DELIVERED: 'delivered',
  INDENT_CANCELLED: 'indent_cancelled',
  READY_FOR_BILLING: 'ready_for_billing',
  INVOICE_GENERATED: 'invoice_generated',
  INVOICE_CHECKED: 'invoice_checked',
  INVOICE_RE_SUBMITTED: 'invoice_re_submitted',
  INVOICE_APPROVED: 'invoice_approved',
  INVOICE_REJECTED: 'invoice_rejected',
  INVOICE_RETURN: 'invoice_return',
  INVOICE_POSTED: 'invoice_posted',
  INVOICE_ON_HOLD: 'invoice_on_hold',
  INVOICE_PAID: 'invoice_paid',
  INVOICE_CANCELLED: 'invoice_cancelled',
  E_INVOICE_MISMATCHED: 'e_invoice_mismatched',
  E_INVOICE_VERIFIED: 'e_invoice_verified',
  INVOICE_CUSTOM: 'invoice_custom',
  INVOICE_PARTIAL: 'invoice_partial_paid',
};

const timelineMessage = {
  indent_created: 'Indent Created',
  vehicle_requirement_date: 'Vehicle Requirement Date',
  vehicle_assigned: 'Vehicle Assigned',
  arrival_sla_breached: 'SLA - Arrival Breach',
  reported: 'Reported',
  source_arrived: 'Arrived at',
  source_dispatched: 'Dispatched at',
  destination_reported: 'Reported at',
  destination_reached: 'Released at',
  delivered: 'Delivered',
  indent_cancelled: 'Indent Cancelled',
  ready_for_billing: 'Ready for billing',
  invoice_generated: 'Invoice Generated',
  invoice_checked: 'Checked by',
  invoice_re_submitted: 'Resubmitted by',
  invoice_approved: 'Approved by',
  invoice_rejected: 'Rejected by',
  invoice_return: 'Returned by',
  invoice_posted: 'Posted',
  invoice_on_hold: 'On-Hold',
  invoice_partial_paid: 'Partial Paid',
  invoice_paid: 'Paid',
  invoice_cancelled: 'Cancelled',
  e_invoice_mismatched: 'E-Invoice Mismatched',
  e_invoice_verified: 'E-Invoice Verified',
  invoice_custom: 'Custom Invoice Status',
};

const timelineUserTypes = {
  SHIPPER: 'shipper',
  TRANSPORTER: 'transporter',
  SYSTEM: 'system',
  CONSIGNEE: 'consignee',
};

const timelineActionType = {
  REQUEST : 'Request',
  APPROVAL:'Approval',
  CHANGE:'Direct Change'
}

module.exports = {
  timelineParentType,
  timelineTitle,
  timelineLabels,
  timelineUserTypes,
  timelineMessage,
  timelineActionType,
};
